import { REDIRECT_STATUS_CODES } from 'src/constants/common';
import { _redirectToOtherRoute, set404Response } from './404Redirect';
import { getRoute } from './routes';
import { PAGE_TYPE_ID } from './constants';

export const PDP_ROUTE_IDENTIFIER = '/product/';
export const CATEGORY_ROUTE_IDENTIFIER = '/shop/';
export const COLLECTION_ROUTE_IDENTIFIER = '/collections/';

/**
 * function for returing product page path following domain.
 * sample product url - "httts://wwww.domain.com/product/remaining_string"
 * then this would return "/product/remaining_string" or "product/remaining_string" depending on the value of startWithSlash.
 * @param productUrl - product link received from backend.
 * @param startWithSlash - tells us whether to start the Path with "/" or not.
 * @returns - path of product following domain - "/product/remaining_string"
 */
export function getProductPathFromUrl(
  productUrl: string,
  startWithSlash: boolean = true
) {
  const splittedArray = productUrl?.split(PDP_ROUTE_IDENTIFIER);
  if (splittedArray?.length > 1) {
    const route = PDP_ROUTE_IDENTIFIER + splittedArray[1];
    return startWithSlash ? route : route?.slice(1);
  } else {
    return '';
  }
}

interface IProductResponse {
  error: {
    response?: {
      status: number;
      data?: {
        data?: string;
      };
    };
  };
}

interface IPropTypes {
  ssrStore?: {
    storeReducer?: {
      store?: {
        domain: string;
      };
    };
  };
}

interface IErrorCaseHandler {
  ctx: any;
  productResponse: IProductResponse;
  propType: IPropTypes;
}

/**
 * This function handles the redirection for pdp page on server side in case of error while fetching product data.
 * if the status code id 3XX - it redirects to new product Url
 * else it would redirect to 404 - Not Fund page.
 * @param {*} ctx
 * @param {*} productResponse
 * @param {*} propType
 */
export function handlePDPErrorCaseRedirection({
  ctx,
  productResponse,
  propType,
}: IErrorCaseHandler) {
  const statusCode: number = productResponse?.error?.response?.status;
  if (REDIRECT_STATUS_CODES.includes(statusCode)) {
    const productItem = JSON.parse(productResponse?.error?.response?.data?.data);
    const newProductPath = getProductPathFromUrl(productItem?.link, false);
    const domainFromStore = propType?.ssrStore?.storeReducer?.store?.domain;
    return _redirectToOtherRoute({
      ctx,
      statusCode,
      route: getRoute(newProductPath, domainFromStore, ctx),
    });
  } else {
     return set404Response(ctx, propType);
  }
}

export function handleCategoryCollectionRedirect({ ctx, redirectionLink, type, propType }: { ctx: any; redirectionLink?: string, type?: number, propType?: IPropTypes }) {
  return {
      redirect: {
        destination: redirectionLink,
        permanent: false, // temporary
      },
    };
}

export function getPathFromUrl(
  url: string,
  startWithSlash: boolean = true,
  type: number
) {
  let identifier;
  if(type === PAGE_TYPE_ID.COLLECTION) {
    identifier = COLLECTION_ROUTE_IDENTIFIER;
  } else if (type === PAGE_TYPE_ID.CATEGORY) {
    identifier = CATEGORY_ROUTE_IDENTIFIER;
  } 
  const splittedArray = url?.split(identifier);
  if (splittedArray?.length > 1) {
    const route = identifier + splittedArray[1];
    return startWithSlash ? route : route?.slice(1);
  } else {
    return '';
  }
}
